<template>
  <v-app>
    <v-toolbar v-if="loggedIn && user" app dark color="blue darken-4" :clipped-left="clipped">
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat @click="goToHome()">Home</v-btn>
        <v-menu v-if="user.securityMask.charAt(0) == '1'" open-on-hover offset-y>
        <!-- <v-menu open-on-hover offset-y> -->
          <v-btn slot="activator" flat>Admin
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
          <v-list light>
            <v-list-tile @click="goToAddUser()">
              <v-list-tile-title>New User</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu open-on-hover offset-y>
          <v-btn slot="activator" flat>
            {{ user.firstName }}
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
          <v-list light>
	   <!--
            <v-list-tile @click="goToProfile">
              <v-list-tile-title>Profile</v-list-tile-title>
            </v-list-tile>
           -->
            <v-list-tile @click="logout">
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <router-view class="view"></router-view>
      <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
      >
        {{ snackbarText }}
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import './scss/_app.scss';
import store from './store';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      clipped: false,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: 'fas fa-sign-out-alt',
          title: 'Logout'
        }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'ActNotify',
      snackbar: false,
      snackbarText: '',
      timeout: 6000,
      y: 'top',
      x: null,
      mode: ''
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      loggedIn: 'auth/isLoggedIn'
    })
  },
  methods: {
    goToProfile() {
      this.$router.push('/user/' + this.user.UserID);
    },
    handleOptions() {},
    goToHome() {
      this.$router.push('/');
      this.showError(null);
    },
    goToSettings() {},
    goToAddUser() {
      this.$router.push('/user');
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/login');
      });
    }
  },
  mounted() {
    this.$root.$on('showSnackbar', msg => {
      this.snackbar = true;
      this.snackbarText = msg;
    });
  }
};
</script>

<style scoped>
</style>
